import { type Skills } from '@air/api';

type SkillsListParams = NonNullable<Parameters<typeof Skills.list>[0]>;

export type UsePrivateSkillsListParams = Omit<SkillsListParams & { type?: 'canvas' }, 'workspaceId' | 'cursor'> & {
  workspaceId: string | undefined;
  /**
   * Workspace agent slash catalog only — omit `type` on `Skills.list` so canvas and organization
   * skills load. Settings / canvas skills UI keep the default `type: 'canvas'`.
   */
  omitSkillListType?: boolean;
};

/** Private-tab lists use `scope: 'private'` only (no `type`). Other scopes default to canvas unless caller passes `type`. */
export const toPrivateSkillsListQueryParams = (params: UsePrivateSkillsListParams): UsePrivateSkillsListParams => {
  const { type: callerType, omitSkillListType, ...rest } = params;

  if (omitSkillListType) {
    return rest;
  }

  return { ...rest, ...(params.scope !== 'private' ? { type: callerType ?? 'canvas' } : {}) };
};
